import React, { createContext, useState } from "react";
import { useEffect } from "react";

export const compareDataContext = createContext();

const CompareContext = ({ children }) => {
  const [compareData, setCompareData] = useState([]);
  const [openCompare, setOpenCompare] = useState(false);

  useEffect(() => {
    compareData.length === 0 && setOpenCompare(false);
  }, [compareData]);

  return (
    <compareDataContext.Provider
      value={{ compareData, setCompareData, openCompare, setOpenCompare }}
    >
      {children}
    </compareDataContext.Provider>
  );
};

export default CompareContext;
